import { render, staticRenderFns } from "./Mode.vue?vue&type=template&id=4010f3b3&scoped=true&"
import script from "./Mode.vue?vue&type=script&lang=js&"
export * from "./Mode.vue?vue&type=script&lang=js&"
import style0 from "./Mode.vue?vue&type=style&index=0&id=4010f3b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010f3b3",
  null
  
)

export default component.exports